import type { Settings } from '../dataProviders/admin/settings';
import type { DentalMaterial } from '../types/DentalMaterial';
import type { Order } from '../types/Order';

export type PricingFields = Pick<Order, 'material_id' | 'number_parts' | 'modeling' | 'type' | 'machine_type'>;

export function calcOrderPrice(order: PricingFields, dentalMaterials: DentalMaterial[] | undefined, settings: Settings | undefined): number | false {
  if (!dentalMaterials || !settings) {
    return false;
  }

  let price = 0;
  //  Milling and has selected a material
  if (order.machine_type === 'milling' && order.material_id && dentalMaterials) {
    const material = dentalMaterials.find(material => material.id === order.material_id);
    price += order.number_parts * (material?.price ?? 0);
  }
  //   3D
  if (order.machine_type === '3d' && settings) {
    price += order.number_parts * (settings.price3D ?? 10);
  }
  //   Models
  if (order.machine_type === 'models' && settings) {
    price += order.number_parts * (settings.priceModels ?? 0);
  }

  if (order.modeling && order.type === 'coping' && settings) {
    price += (settings.priceCoping ?? 0);
  }
  else if (order.modeling && order.type === 'fullcontour' && settings) {
    price += (settings.priceFullctr ?? 0);
  }

  return price;
}
